var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container feedback template-bg-gray" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 main-sec" },
        [
          _c(
            "div",
            {
              staticClass:
                "loop_container bg-transparent update-request-form-common"
            },
            [
              _c(
                "div",
                {
                  staticClass: "card form-wrapper",
                  class: {
                    "feedback-update-boxplr":
                      !_vm.isBeforRequest && !_vm.isSubmitForm,
                    thankupageplr88: !_vm.isBeforRequest && _vm.isSubmitForm
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "feedback_container feedback_newupdate" },
                    [
                      _c(
                        "div",
                        { staticClass: "row" },
                        [
                          _vm.isShow
                            ? _c("div", { staticClass: "community-logo" }, [
                                _c("img", {
                                  staticClass: "top-logo custom-logo",
                                  attrs: {
                                    src: _vm.logoURL,
                                    alt:
                                      _vm.community.content &&
                                      _vm.community.content.parameter2
                                        ? _vm.community.content.parameter2
                                        : "Community Logo"
                                  }
                                })
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("CustomSkeleton", {
                            attrs: { "is-visible": !_vm.isShow }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      this.isBeforRequest && _vm.isShow
                        ? [
                            _c(
                              "h2",
                              {
                                staticClass:
                                  "template-title common-space-from-logo"
                              },
                              [_vm._v("What do you need help with?")]
                            ),
                            _vm._v(" "),
                            _vm.community.content &&
                            _vm.community.content.requestIntroduction &&
                            !this.isSubmitForm
                              ? _c("div", [
                                  _c("p", {
                                    staticClass:
                                      "box-sub-heading mb35 custom-content",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.community.content
                                          .requestIntroduction
                                      )
                                    }
                                  })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "form",
                              {
                                staticClass: "template-form",
                                attrs: {
                                  autocomplete: "off",
                                  "data-vv-scope": "form-request"
                                },
                                on: {
                                  submit: function($event) {
                                    $event.preventDefault()
                                    return _vm.save("form-request")
                                  }
                                }
                              },
                              [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-6 mb-17" }, [
                                    _c("div", { staticClass: "input-group" }, [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "template-label",
                                          attrs: { for: "firstName" }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.configureFields.firstName
                                                .labelName
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "required-symbol" },
                                        [_vm._v(" *")]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.ask.first,
                                            expression: "ask.first"
                                          },
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'"
                                          },
                                          { name: "focus", rawName: "v-focus" }
                                        ],
                                        ref: "firstName",
                                        staticClass:
                                          "form-control input-value pt-input input-focus",
                                        class: {
                                          "request-form-error-border": _vm.errors.has(
                                            "form-request.first"
                                          )
                                        },
                                        attrs: {
                                          type: "text",
                                          id: "firstName",
                                          autocomplete: "given-name",
                                          name: "first",
                                          placeholder: "",
                                          "data-vv-validate-on": "change"
                                        },
                                        domProps: { value: _vm.ask.first },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.ask,
                                              "first",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.errors.has(
                                                "form-request.first"
                                              ),
                                              expression:
                                                "errors.has('form-request.first')"
                                            }
                                          ],
                                          staticClass: "error"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.errors.first(
                                                "form-request.first"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-6 mb-17" }, [
                                    _c("div", { staticClass: "input-group" }, [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "template-label",
                                          attrs: { for: "lastName" }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.configureFields.lastName
                                                .labelName
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "required-symbol" },
                                        [_vm._v(" *")]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.ask.last,
                                            expression: "ask.last"
                                          },
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'"
                                          }
                                        ],
                                        staticClass:
                                          "form-control input-value pt-input input-focus",
                                        class: {
                                          "request-form-error-border": _vm.errors.has(
                                            "form-request.last"
                                          )
                                        },
                                        attrs: {
                                          type: "text",
                                          id: "lastName",
                                          autocomplete: "family-name",
                                          name: "last",
                                          placeholder: "",
                                          "data-vv-validate-on": "change"
                                        },
                                        domProps: { value: _vm.ask.last },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.ask,
                                              "last",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.errors.has(
                                                "form-request.last"
                                              ),
                                              expression:
                                                "errors.has('form-request.last')"
                                            }
                                          ],
                                          staticClass: "error"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.errors.first(
                                                "form-request.last"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-6 mb-17" }, [
                                    _c("div", { staticClass: "input-group" }, [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "template-label",
                                          attrs: { for: "email" }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.configureFields.emailAddress
                                                .labelName
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "required-symbol" },
                                        [_vm._v(" *")]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.ask.email,
                                            expression: "ask.email"
                                          },
                                          {
                                            name: "validate",
                                            rawName: "v-validate.continues",
                                            value: "required|email",
                                            expression: "'required|email'",
                                            modifiers: { continues: true }
                                          }
                                        ],
                                        staticClass:
                                          "form-control input-value pt-input input-focus",
                                        class: {
                                          "request-form-error-border": _vm.errors.has(
                                            "form-request.email"
                                          )
                                        },
                                        attrs: {
                                          type: "email",
                                          id: "email",
                                          name: "email",
                                          placeholder: "",
                                          autocomplete: "email",
                                          "data-vv-validate-on": "change"
                                        },
                                        domProps: { value: _vm.ask.email },
                                        on: {
                                          change: _vm.checkMemberStatus,
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.ask,
                                              "email",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.errors.has(
                                                "form-request.email"
                                              ),
                                              expression:
                                                "errors.has('form-request.email')"
                                            }
                                          ],
                                          staticClass: "error"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.errors.first(
                                                "form-request.email"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm.configureFields.memberRole &&
                                    _vm.configureFields.memberRole.include &&
                                    _vm.configureFields.memberRole.include ===
                                      true
                                      ? _c(
                                          "div",
                                          { staticClass: "col-md-6 mb-17" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "input-group" },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "template-label",
                                                    attrs: { for: "memberRole" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.memberRole.labelName
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm.checkAndValidate1(
                                                  "memberRole"
                                                )
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "required-symbol"
                                                      },
                                                      [_vm._v(" *")]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value:
                                                          "" +
                                                          _vm.checkAndValidate1(
                                                            "memberRole"
                                                          ),
                                                        expression:
                                                          "`${checkAndValidate1('memberRole')}`"
                                                      },
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.dynamicFields
                                                            .memberRole,
                                                        expression:
                                                          "dynamicFields.memberRole"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "form-control input-value template-drop-down pt-input input-focus select-dropdown requestPageDropdown",
                                                    attrs: {
                                                      name: "memberRole",
                                                      id: "memberRole",
                                                      "data-vv-validate-on":
                                                        "change|blur"
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                        _vm.$set(
                                                          _vm.dynamicFields,
                                                          "memberRole",
                                                          $event.target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "option",
                                                      {
                                                        staticStyle: {
                                                          display: "none"
                                                        },
                                                        attrs: {
                                                          value: "",
                                                          selected: "",
                                                          disabled: ""
                                                        }
                                                      },
                                                      [_vm._v("Select role")]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      _vm.memberRole
                                                        .memberValue,
                                                      function(role) {
                                                        return _c(
                                                          "option",
                                                          {
                                                            key: role,
                                                            domProps: {
                                                              value: role.trim()
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                role.trim()
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "p",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value: _vm.errors.has(
                                                          "form-request.memberRole"
                                                        ),
                                                        expression:
                                                          "errors.has('form-request.memberRole')"
                                                      }
                                                    ],
                                                    staticClass: "error"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.errors.first(
                                                          "form-request.memberRole"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.configureFields.adviceArea &&
                                    _vm.configureFields.adviceArea.include &&
                                    _vm.configureFields.adviceArea.include ===
                                      true
                                      ? _c(
                                          "div",
                                          { staticClass: "col-md-6 mb-17" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "input-group" },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "template-label",
                                                    attrs: { for: "adviceArea" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.adviceArea.labelName
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm.checkAndValidate1(
                                                  "adviceArea"
                                                )
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "required-symbol"
                                                      },
                                                      [_vm._v(" *")]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value:
                                                          "" +
                                                          _vm.checkAndValidate1(
                                                            "adviceArea"
                                                          ),
                                                        expression:
                                                          "`${checkAndValidate1('adviceArea')}`"
                                                      },
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.dynamicFields
                                                            .adviceArea,
                                                        expression:
                                                          "dynamicFields.adviceArea"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "form-control input-value template-drop-down pt-input input-focus select-dropdown requestPageDropdown",
                                                    attrs: {
                                                      name: "adviceArea",
                                                      id: "adviceArea",
                                                      "data-vv-validate-on":
                                                        "change|blur"
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                        _vm.$set(
                                                          _vm.dynamicFields,
                                                          "adviceArea",
                                                          $event.target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "option",
                                                      {
                                                        staticStyle: {
                                                          display: "none"
                                                        },
                                                        attrs: {
                                                          value: "",
                                                          selected: "",
                                                          disabled: ""
                                                        }
                                                      },
                                                      [_vm._v("Select Area")]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      _vm.adviceArea
                                                        .memberValue,
                                                      function(role) {
                                                        return _c(
                                                          "option",
                                                          {
                                                            key: role,
                                                            domProps: {
                                                              value: role.trim()
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                role.trim()
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "p",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value: _vm.errors.has(
                                                          "form-request.adviceArea"
                                                        ),
                                                        expression:
                                                          "errors.has('form-request.adviceArea')"
                                                      }
                                                    ],
                                                    staticClass: "error"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.errors.first(
                                                          "form-request.adviceArea"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.configureFields.phoneNumber &&
                                    _vm.configureFields.phoneNumber.include &&
                                    _vm.configureFields.phoneNumber.include ===
                                      true
                                      ? _c(
                                          "div",
                                          { staticClass: "col-md-6 mb-17" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "input-group" },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "template-label",
                                                    attrs: {
                                                      for: "phoneNumber"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.configureFields
                                                          .phoneNumber.labelName
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm.checkAndValidate1(
                                                  "phoneNumber"
                                                )
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "required-symbol"
                                                      },
                                                      [_vm._v(" *")]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.dynamicFields
                                                          .phoneNumber,
                                                      expression:
                                                        "dynamicFields.phoneNumber"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName:
                                                        "v-validate.continues",
                                                      value:
                                                        "" +
                                                        _vm.checkAndValidate1(
                                                          "phoneNumber"
                                                        ),
                                                      expression:
                                                        "`${checkAndValidate1('phoneNumber')}`",
                                                      modifiers: {
                                                        continues: true
                                                      }
                                                    }
                                                  ],
                                                  staticClass:
                                                    "form-control input-value pt-input input-focus",
                                                  class: {
                                                    "request-form-error-border": _vm.errors.has(
                                                      "form-request.phoneNumber"
                                                    )
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    id: "phoneNumber",
                                                    name: "phoneNumber",
                                                    "data-vv-validate-on":
                                                      "change"
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.dynamicFields
                                                        .phoneNumber
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.dynamicFields,
                                                        "phoneNumber",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "p",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value: _vm.errors.has(
                                                          "form-request.phoneNumber"
                                                        ),
                                                        expression:
                                                          "errors.has('form-request.phoneNumber')"
                                                      }
                                                    ],
                                                    staticClass: "error"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.errors.first(
                                                          "form-request.phoneNumber"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.configureFields.linkedInProfile &&
                                    _vm.configureFields.linkedInProfile
                                      .include &&
                                    _vm.configureFields.linkedInProfile
                                      .include === true
                                      ? _c(
                                          "div",
                                          { staticClass: "col-md-12 mb-17" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "input-group" },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "template-label",
                                                    attrs: {
                                                      for: "linkedInProfile"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.configureFields
                                                          .linkedInProfile
                                                          .labelName
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm.checkAndValidate1(
                                                  "linkedInProfile"
                                                )
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "required-symbol"
                                                      },
                                                      [_vm._v(" *")]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.dynamicFields
                                                          .linkedInProfile,
                                                      expression:
                                                        "dynamicFields.linkedInProfile"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required:
                                                          _vm.configureFields
                                                            .linkedInProfile
                                                            .require == true
                                                            ? true
                                                            : false,
                                                        regex: /^http(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&%\$#_]*)?$/
                                                      },
                                                      expression:
                                                        "{ required: configureFields.linkedInProfile.require == true ? true: false, regex: /^http(s?)\\:\\/\\/[0-9a-zA-Z]([-.\\w]*[0-9a-zA-Z])*(:(0-9)*)*(\\/?)([a-zA-Z0-9\\-\\.\\?\\,\\'\\/\\\\\\+&%\\$#_]*)?$/ }"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "form-control input-value pt-input input-focus",
                                                  class: {
                                                    "request-form-error-border": _vm.errors.has(
                                                      "form-request.linkedInProfile"
                                                    )
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    id: "linkedInProfile",
                                                    name: "linkedInProfile",
                                                    "data-vv-validate-on":
                                                      "change"
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.dynamicFields
                                                        .linkedInProfile
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.dynamicFields,
                                                        "linkedInProfile",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "p",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value: _vm.errors.has(
                                                          "form-request.linkedInProfile"
                                                        ),
                                                        expression:
                                                          "errors.has('form-request.linkedInProfile')"
                                                      }
                                                    ],
                                                    staticClass: "error"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.errors.first(
                                                          "form-request.linkedInProfile"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.configureFields.college &&
                                    _vm.configureFields.college.include &&
                                    _vm.configureFields.college.include === true
                                      ? _c(
                                          "div",
                                          { staticClass: "col-md-6 mb-17" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "input-group" },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "template-label",
                                                    attrs: { for: "college" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.configureFields
                                                          .college.labelName
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm.checkAndValidate1("college")
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "required-symbol"
                                                      },
                                                      [_vm._v(" *")]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.dynamicFields
                                                          .college,
                                                      expression:
                                                        "dynamicFields.college"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName:
                                                        "v-validate.continues",
                                                      value:
                                                        "" +
                                                        _vm.checkAndValidate1(
                                                          "college"
                                                        ),
                                                      expression:
                                                        "`${checkAndValidate1('college')}`",
                                                      modifiers: {
                                                        continues: true
                                                      }
                                                    }
                                                  ],
                                                  staticClass:
                                                    "form-control input-value pt-input input-focus",
                                                  class: {
                                                    "request-form-error-border": _vm.errors.has(
                                                      "form-request.college"
                                                    )
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    id: "college",
                                                    name: "college",
                                                    "data-vv-validate-on":
                                                      "change"
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.dynamicFields.college
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.dynamicFields,
                                                        "college",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "p",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value: _vm.errors.has(
                                                          "form-request.college"
                                                        ),
                                                        expression:
                                                          "errors.has('form-request.college')"
                                                      }
                                                    ],
                                                    staticClass: "error"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.errors.first(
                                                          "form-request.college"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.configureFields.classYear &&
                                    _vm.configureFields.classYear.include &&
                                    _vm.configureFields.classYear.include ===
                                      true
                                      ? _c(
                                          "div",
                                          { staticClass: "col-md-6 mb-17" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "input-group" },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "template-label",
                                                    attrs: { for: "year" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.configureFields
                                                          .classYear.labelName
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm.checkAndValidate1("year")
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "required-symbol"
                                                      },
                                                      [_vm._v(" *")]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.dynamicFields.year,
                                                      expression:
                                                        "dynamicFields.year"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName:
                                                        "v-validate.continues",
                                                      value:
                                                        "" +
                                                        _vm.checkAndValidate1(
                                                          "year"
                                                        ),
                                                      expression:
                                                        "`${checkAndValidate1('year')}`",
                                                      modifiers: {
                                                        continues: true
                                                      }
                                                    }
                                                  ],
                                                  staticClass:
                                                    "form-control input-value pt-input input-focus",
                                                  class: {
                                                    "request-form-error-border": _vm.errors.has(
                                                      "form-request.year"
                                                    )
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    id: "year",
                                                    name: "year",
                                                    "data-vv-validate-on":
                                                      "change"
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.dynamicFields.year
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.dynamicFields,
                                                        "year",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "p",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value: _vm.errors.has(
                                                          "form-request.year"
                                                        ),
                                                        expression:
                                                          "errors.has('form-request.year')"
                                                      }
                                                    ],
                                                    staticClass: "error"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.errors.first(
                                                          "form-request.year"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.configureFields.title &&
                                    _vm.configureFields.title.include &&
                                    _vm.configureFields.title.include === true
                                      ? _c(
                                          "div",
                                          { staticClass: "col-md-6 mb-17" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "input-group" },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "template-label",
                                                    attrs: { for: "role" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.configureFields
                                                          .title.labelName
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm.checkAndValidate1("role")
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "required-symbol"
                                                      },
                                                      [_vm._v(" *")]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.dynamicFields.role,
                                                      expression:
                                                        "dynamicFields.role"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName:
                                                        "v-validate.continues",
                                                      value:
                                                        "" +
                                                        _vm.checkAndValidate1(
                                                          "role"
                                                        ),
                                                      expression:
                                                        "`${checkAndValidate1('role')}`",
                                                      modifiers: {
                                                        continues: true
                                                      }
                                                    }
                                                  ],
                                                  staticClass:
                                                    "form-control input-value pt-input input-focus",
                                                  class: {
                                                    "request-form-error-border": _vm.errors.has(
                                                      "form-request.role"
                                                    )
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    id: "role",
                                                    name: "role",
                                                    "data-vv-validate-on":
                                                      "change"
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.dynamicFields.role
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.dynamicFields,
                                                        "role",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "p",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value: _vm.errors.has(
                                                          "form-request.role"
                                                        ),
                                                        expression:
                                                          "errors.has('form-request.role')"
                                                      }
                                                    ],
                                                    staticClass: "error"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.errors.first(
                                                          "form-request.role"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.configureFields.organization &&
                                    _vm.configureFields.organization.include &&
                                    _vm.configureFields.organization.include ===
                                      true
                                      ? _c(
                                          "div",
                                          { staticClass: "col-md-6 mb-17" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "input-group" },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "template-label",
                                                    attrs: {
                                                      for: "organization"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.configureFields
                                                          .organization
                                                          .labelName
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm.checkAndValidate1(
                                                  "organization"
                                                )
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "required-symbol"
                                                      },
                                                      [_vm._v(" *")]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.dynamicFields
                                                          .organization,
                                                      expression:
                                                        "dynamicFields.organization"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName:
                                                        "v-validate.continues",
                                                      value:
                                                        "" +
                                                        _vm.checkAndValidate1(
                                                          "organization"
                                                        ),
                                                      expression:
                                                        "`${checkAndValidate1('organization')}`",
                                                      modifiers: {
                                                        continues: true
                                                      }
                                                    }
                                                  ],
                                                  staticClass:
                                                    "form-control input-value pt-input input-focus",
                                                  class: {
                                                    "request-form-error-border": _vm.errors.has(
                                                      "form-request.organization"
                                                    )
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    id: "organization",
                                                    name: "organization",
                                                    "data-vv-validate-on":
                                                      "change"
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.dynamicFields
                                                        .organization
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.dynamicFields,
                                                        "organization",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "p",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value: _vm.errors.has(
                                                          "form-request.organization"
                                                        ),
                                                        expression:
                                                          "errors.has('form-request.organization')"
                                                      }
                                                    ],
                                                    staticClass: "error"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.errors.first(
                                                          "form-request.organization"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.configureFields.studentId &&
                                    _vm.configureFields.studentId.include &&
                                    _vm.configureFields.studentId.include ===
                                      true
                                      ? _c(
                                          "div",
                                          { staticClass: "col-md-6 mb-17" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "input-group" },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "template-label",
                                                    attrs: { for: "studentId" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.configureFields
                                                          .studentId.labelName
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm.checkAndValidate1(
                                                  "studentId"
                                                )
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "required-symbol"
                                                      },
                                                      [_vm._v(" *")]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.dynamicFields
                                                          .studentId,
                                                      expression:
                                                        "dynamicFields.studentId"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName:
                                                        "v-validate.continues",
                                                      value:
                                                        "" +
                                                        _vm.checkAndValidate1(
                                                          "studentId"
                                                        ),
                                                      expression:
                                                        "`${checkAndValidate1('studentId')}`",
                                                      modifiers: {
                                                        continues: true
                                                      }
                                                    }
                                                  ],
                                                  staticClass:
                                                    "form-control input-value pt-input input-focus",
                                                  class: {
                                                    "request-form-error-border": _vm.errors.has(
                                                      "form-request.studentId"
                                                    )
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    id: "studentId",
                                                    name: "studentId",
                                                    "data-vv-validate-on":
                                                      "change"
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.dynamicFields
                                                        .studentId
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.dynamicFields,
                                                        "studentId",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "p",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value: _vm.errors.has(
                                                          "form-request.studentId"
                                                        ),
                                                        expression:
                                                          "errors.has('form-request.studentId')"
                                                      }
                                                    ],
                                                    staticClass: "error"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.errors.first(
                                                          "form-request.studentId"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.configureFields.referrer &&
                                    _vm.configureFields.referrer.include &&
                                    _vm.configureFields.referrer.include ===
                                      true
                                      ? _c(
                                          "div",
                                          { staticClass: "col-md-12 mb-17" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "input-group" },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "template-label",
                                                    attrs: { for: "referrer" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.configureFields
                                                          .referrer.labelName
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm.checkAndValidate1(
                                                  "referrer"
                                                )
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "required-symbol"
                                                      },
                                                      [_vm._v(" *")]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.dynamicFields
                                                          .referrer,
                                                      expression:
                                                        "dynamicFields.referrer"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName:
                                                        "v-validate.continues",
                                                      value:
                                                        "" +
                                                        _vm.checkAndValidate1(
                                                          "referrer"
                                                        ),
                                                      expression:
                                                        "`${checkAndValidate1('referrer')}`",
                                                      modifiers: {
                                                        continues: true
                                                      }
                                                    }
                                                  ],
                                                  staticClass:
                                                    "form-control input-value pt-input input-focus",
                                                  class: {
                                                    "request-form-error-border": _vm.errors.has(
                                                      "form-request.referrer"
                                                    )
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    id: "referrer",
                                                    name: "referrer",
                                                    "data-vv-validate-on":
                                                      "change"
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.dynamicFields.referrer
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.dynamicFields,
                                                        "referrer",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "p",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value: _vm.errors.has(
                                                          "form-request.referrer"
                                                        ),
                                                        expression:
                                                          "errors.has('form-request.referrer')"
                                                      }
                                                    ],
                                                    staticClass: "error"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.errors.first(
                                                          "form-request.referrer"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.configureFields.referrer2 &&
                                    _vm.configureFields.referrer2.include &&
                                    _vm.configureFields.referrer2.include ===
                                      true
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "input-group" },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "template-label",
                                                    attrs: { for: "referrer2" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.configureFields
                                                          .referrer2.labelName
                                                      )
                                                    ),
                                                    _vm.checkAndValidate1(
                                                      "referrer2"
                                                    )
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "required-symbol"
                                                          },
                                                          [_vm._v(" *")]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value:
                                                          "" +
                                                          _vm.checkAndValidate1(
                                                            "referrer2"
                                                          ),
                                                        expression:
                                                          "`${checkAndValidate1('referrer2')}`"
                                                      },
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.dynamicFields
                                                            .referrer2,
                                                        expression:
                                                          "dynamicFields.referrer2"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "form-control template-drop-down input-value pt-input input-focus select-dropdown requestPageDropdown",
                                                    attrs: {
                                                      id: "referrer2",
                                                      name: "referrer2",
                                                      "data-vv-validate-on":
                                                        "change"
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                        _vm.$set(
                                                          _vm.dynamicFields,
                                                          "referrer2",
                                                          $event.target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "option",
                                                      {
                                                        staticStyle: {
                                                          display: "none"
                                                        },
                                                        attrs: {
                                                          value: "",
                                                          selected: "",
                                                          disabled: ""
                                                        }
                                                      },
                                                      [_vm._v("Select")]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      _vm.referrer2.memberValue,
                                                      function(degree, idx) {
                                                        return _c(
                                                          "option",
                                                          {
                                                            key:
                                                              "referrer-" + idx,
                                                            domProps: {
                                                              value: degree.trim()
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                degree.trim()
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "p",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value: _vm.errors.has(
                                                          "step-1.referrer2"
                                                        ),
                                                        expression:
                                                          "errors.has('step-1.referrer2')"
                                                      }
                                                    ],
                                                    staticClass: "error"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.errors.first(
                                                          "step-1.referrer2"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-12 mb-17" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input-group" },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass: "template-label",
                                              attrs: { for: "title" }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.configureFields.subject
                                                    .labelName
                                                )
                                              )
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "required-symbol" },
                                            [_vm._v(" *")]
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.ask.subject,
                                                expression: "ask.subject"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            staticClass:
                                              "form-control input-value pt-input w-100 input-focus",
                                            class: {
                                              "request-form-error-border": _vm.errors.has(
                                                "form-request.title"
                                              )
                                            },
                                            attrs: {
                                              type: "text",
                                              id: "title",
                                              placeholder: this.requestForm
                                                .subjectLine,
                                              name: "title",
                                              "data-vv-validate-on": "change"
                                            },
                                            domProps: {
                                              value: _vm.ask.subject
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  _vm.ask,
                                                  "subject",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.errors.has(
                                                    "form-request.title"
                                                  ),
                                                  expression:
                                                    "errors.has('form-request.title')"
                                                }
                                              ],
                                              staticClass: "error"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.errors.first(
                                                    "form-request.title"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.configureFields.dueDate &&
                                  _vm.configureFields.dueDate.include &&
                                  _vm.configureFields.dueDate.include === true
                                    ? _c("div", { staticClass: "col-md-12" }, [
                                        _c(
                                          "div",
                                          { staticClass: "input-group" },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass: "template-label",
                                                attrs: { for: "dueDate" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.configureFields.dueDate
                                                      .labelName
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm.checkAndValidate1("dueDate")
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "required-symbol"
                                                  },
                                                  [_vm._v(" *")]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("datepicker", {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName:
                                                    "v-validate.continues",
                                                  value:
                                                    "" +
                                                    _vm.checkAndValidate1(
                                                      "dueDate"
                                                    ),
                                                  expression:
                                                    "`${checkAndValidate1('dueDate')}`",
                                                  modifiers: { continues: true }
                                                }
                                              ],
                                              staticClass:
                                                "input-focus template-input-date-picker",
                                              class: {
                                                "request-form-error-border": _vm.errors.has(
                                                  "form-request.dueDate"
                                                )
                                              },
                                              attrs: {
                                                id: "dueDate",
                                                name: "dueDate",
                                                format: _vm.DatePickerFormat,
                                                disabledDates:
                                                  _vm.disabledDates,
                                                "data-vv-validate-on":
                                                  "change|blur"
                                              },
                                              model: {
                                                value:
                                                  _vm.dynamicFields.dueDate,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.dynamicFields,
                                                    "dueDate",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "dynamicFields.dueDate"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._m(0),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.errors.has(
                                                      "form-request.dueDate"
                                                    ),
                                                    expression:
                                                      "errors.has('form-request.dueDate')"
                                                  }
                                                ],
                                                staticClass: "error"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.errors.first(
                                                      "form-request.dueDate"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-12" }, [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "template-label",
                                        attrs: { for: "message" }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.configureFields.question
                                              .labelName
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "required-symbol" },
                                      [_vm._v(" *")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "input-group pd-remove unsubscribe-height input-focus request-form-question-container template-input-text-area common-question-textarea-for-v1-v2"
                                      },
                                      [
                                        _c("textarea", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.ask.text,
                                              expression: "ask.text"
                                            },
                                            {
                                              name: "validate",
                                              rawName: "v-validate.continues",
                                              value: "required|max:2000",
                                              expression: "'required|max:2000'",
                                              modifiers: { continues: true }
                                            }
                                          ],
                                          staticClass:
                                            "form-control pt-input request-form-question-textarea",
                                          class: {
                                            "request-form-error-border": _vm.errors.has(
                                              "form-request.message"
                                            )
                                          },
                                          attrs: {
                                            id: "message",
                                            placeholder: this.requestForm
                                              .question,
                                            "aria-label": "Question",
                                            name: "message",
                                            maxlength: _vm.max,
                                            rows: "21",
                                            "data-vv-validate-on": "change"
                                          },
                                          domProps: { value: _vm.ask.text },
                                          on: {
                                            keyup: _vm.countdown,
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.ask,
                                                "text",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "form-group pd-remove unsubscribe-btn mb-0-custom"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "char-counter template-subject-counter",
                                                class: {
                                                  "char-count-error":
                                                    _vm.exceedsMaxCount
                                                },
                                                attrs: { "aria-live": "polite" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.remainingCount) +
                                                    "  / 2000"
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass: "error error-mb--2",
                                        attrs: { id: "question-field-error" }
                                      },
                                      _vm._l(
                                        _vm.errors.collect(
                                          "form-request.message"
                                        ),
                                        function(error, index) {
                                          return _c("span", { key: index }, [
                                            _vm._v(_vm._s(error))
                                          ])
                                        }
                                      ),
                                      0
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _vm.configureFields.disclaimer &&
                                _vm.configureFields.disclaimer.include &&
                                _vm.configureFields.disclaimer.include === true
                                  ? _c("div", { staticClass: "row mlr0" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "form-group disclaimer"
                                        },
                                        [
                                          _c("md-checkbox", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate.continues",
                                                value:
                                                  "" +
                                                  _vm.checkAndValidate1(
                                                    "disclaimer"
                                                  ),
                                                expression:
                                                  "`${checkAndValidate1('disclaimer')}`",
                                                modifiers: { continues: true }
                                              }
                                            ],
                                            staticClass:
                                              "form-control template-checkbox pt-0",
                                            attrs: {
                                              name: "disclaimer",
                                              id: "disclaimer"
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.updateDisclaimer()
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.dynamicFields.disclaimer,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.dynamicFields,
                                                  "disclaimer",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "dynamicFields.disclaimer"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("label", {
                                            staticClass: "html-disclaimer",
                                            attrs: { for: "disclaimer" },
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.configureFields.disclaimer
                                                  .labelName
                                              )
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.errors.has(
                                                    "form-request.disclaimer"
                                                  ),
                                                  expression:
                                                    "errors.has('form-request.disclaimer')"
                                                }
                                              ],
                                              staticClass:
                                                "error error-mt-2 template-checkbox-error"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.errors.first(
                                                    "form-request.disclaimer"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.configureFields.disclaimer &&
                                _vm.configureFields.disclaimer.include === false
                                  ? _c("div", { staticClass: "template-mb-30" })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "btn-block text-right mlr0 text-center-xs"
                                  },
                                  [
                                    _c(
                                      "md-button",
                                      {
                                        staticClass:
                                          "btn btn_info template-review-submit template-button template-button-width",
                                        style: _vm.reviewBtn,
                                        attrs: {
                                          type: "submit",
                                          name: "unsubscribe"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Next\n                                                  "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.isBeforRequest && !_vm.isSubmitForm,
                              expression: "!isBeforRequest && !isSubmitForm"
                            }
                          ],
                          staticClass: "form-template"
                        },
                        [
                          _c(
                            "h2",
                            {
                              staticClass:
                                "template-title common-space-from-logo"
                            },
                            [_vm._v("Ready for your close-up?")]
                          ),
                          _vm._v(" "),
                          _vm.community.content &&
                          _vm.community.content.formConfirmation
                            ? _c("p", {
                                staticClass: "custom-content",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.community.content.formConfirmation
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("hr", { staticClass: "template-hr-custom" }),
                          _vm._v(" "),
                          _c("div", { staticClass: "about-feedbackreq" }, [
                            _c(
                              "div",
                              { staticClass: "template-request-review" },
                              [
                                _vm.ask.first && _vm.ask.last
                                  ? _c(
                                      "h2",
                                      {
                                        attrs: {
                                          "aria-level": "2",
                                          role: "Presentation"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.ask.first + " " + _vm.ask.last
                                          )
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("tr", [
                                  _c(
                                    "td",
                                    {
                                      staticClass: "fs_15 lh_111",
                                      staticStyle: {
                                        "font-family":
                                          "'Roboto',Helvetica Neue,Helvetica,Arial,sans-serif",
                                        "text-align": "left",
                                        "font-size": "18px",
                                        color: "#777479",
                                        "mso-line-height-rule": "exactly",
                                        "line-height": "20px"
                                      },
                                      attrs: { role: "Presentation" }
                                    },
                                    [
                                      _vm.dynamicFields.college || _vm.school
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.dynamicFields.college ||
                                                  _vm.school
                                              )
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.dynamicFields.year || _vm.year
                                        ? _c("span", [
                                            _vm._v(
                                              " (" +
                                                _vm._s(
                                                  _vm.dynamicFields.year ||
                                                    _vm.year
                                                ) +
                                                ")"
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c(
                                  "h2",
                                  {
                                    attrs: {
                                      "aria-level": "2",
                                      role: "Presentation"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.ask.subject))]
                                ),
                                _vm._v(" "),
                                _c("p", { staticClass: "font-color" }, [
                                  _vm._v(_vm._s(_vm.ask.text))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "row back-next-step-2 pl-25 pr-25"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "text-center-xs float-left" },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "btn btn_info template-review-edit template-button template-button-width mb-10",
                                        style: _vm.styleEditBtn,
                                        attrs: {
                                          href: "javaScript:void(0)",
                                          tabindex: "0",
                                          role: "button"
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.isBeforRequest = true
                                          }
                                        }
                                      },
                                      [_vm._v("Back")]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "text-center-xs float-right" },
                                  [
                                    _c(
                                      "md-button",
                                      {
                                        staticClass:
                                          "btn btn_info template-review-submit template-button template-button-width",
                                        style: _vm.styleSubmitBtn,
                                        attrs: {
                                          tabindex: "0",
                                          disabled:
                                            _vm.disabledBtn == 1 ? true : false
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.sendCreate()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Submit\n                                         "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      this.isSubmitForm &&
                      !this.unsubscribe &&
                      !this.spamEmail &&
                      !this.invalidMember
                        ? [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "header-text common-space-from-logo text-center unsubscribepage-thankumsg darken-request-confirmation"
                              },
                              [
                                _c(
                                  "h2",
                                  {
                                    staticClass:
                                      "box-heading thankyou-template-title",
                                    attrs: {
                                      role: "alert",
                                      "aria-live": "Assertive"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        So what's next?\n                                    "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.community.content &&
                                _vm.community.content.requestPageThankYou
                                  ? _c("div", {
                                      staticClass:
                                        "box-sub-heading text-left content-textleft thankyou-custom-content",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.community.content
                                            .requestPageThankYou
                                        )
                                      }
                                    })
                                  : _c(
                                      "div",
                                      {
                                        staticClass:
                                          "box-sub-heading text-left content-textleft thankyou-custom-content"
                                      },
                                      [
                                        _vm._v(
                                          "We will now recruit the right experts to help you."
                                        )
                                      ]
                                    )
                              ]
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      this.unsubscribe && this.isSubmitForm
                        ? [_vm._m(1)]
                        : _vm._e(),
                      _vm._v(" "),
                      this.spamEmail && this.isSubmitForm
                        ? [_vm._m(2)]
                        : _vm._e(),
                      _vm._v(" "),
                      this.invalidMember && this.isSubmitForm
                        ? [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "header-text common-space-from-logo text-left"
                              },
                              [
                                _c(
                                  "h2",
                                  {
                                    staticClass:
                                      "box-heading thankyou-template-title"
                                  },
                                  [_vm._v("Ooops. We’re really sorry. ")]
                                ),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass:
                                    "box-sub-heading text-left content-textleft thankyou-custom-content",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.finalInvalidMemberMessage
                                    )
                                  }
                                })
                              ]
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "list-inline text-center footer-links" },
                [
                  _c("li", [
                    _vm.community.content &&
                    _vm.community.content.landingPageURL &&
                    _vm.community.content.landingPageURL.length
                      ? _c(
                          "a",
                          {
                            staticClass: "links",
                            attrs: {
                              href: _vm.community.content.landingPageURL,
                              target: "_blank"
                            }
                          },
                          [_vm._v("Learn More")]
                        )
                      : _c("a", { attrs: { href: "javascript:void(0)" } }, [
                          _vm._v("Learn More")
                        ])
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm.community.content &&
                    _vm.community.content.termsConditionsURL &&
                    _vm.community.content.termsConditionsURL.length
                      ? _c(
                          "a",
                          {
                            staticClass: "links",
                            attrs: {
                              href: _vm.community.content.termsConditionsURL,
                              target: "_blank"
                            }
                          },
                          [_vm._v("Terms Of Use")]
                        )
                      : _c("a", { attrs: { href: "javascript:void(0)" } }, [
                          _vm._v("Terms Of Use")
                        ])
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm.community.content &&
                    _vm.community.content.unsubscribePageURL &&
                    _vm.community.content.unsubscribePageURL.length
                      ? _c(
                          "a",
                          {
                            staticClass: "links",
                            attrs: {
                              href: _vm.community.content.unsubscribePageURL,
                              target: "_blank"
                            }
                          },
                          [_vm._v("Opt Out")]
                        )
                      : _c("a", { attrs: { href: "javascript:void(0)" } }, [
                          _vm._v("Opt Out")
                        ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "unsubscribe-community-logo" }, [
                _c(
                  "a",
                  {
                    attrs: { href: "https://www.protopia.co", target: "_blank" }
                  },
                  [
                    _c("img", {
                      attrs: { src: _vm.footerLogoURL, alt: "Community Logo" }
                    })
                  ]
                )
              ])
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { staticClass: "helper-text template-label mb-0-custom" },
      [
        _c("strong", [_vm._v("Note:")]),
        _vm._v(
          " Does your request have an expiration date after which an answer is no longer desirable?"
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "header-text common-space-from-logo text-center unsubscribepage-thankumsg"
      },
      [
        _c(
          "div",
          {
            staticClass:
              "box-sub-heading thankyou-custom-content content-textleft text-warning"
          },
          [_vm._v("Your email address has been unsubscribed.")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "header-text common-space-from-logo text-center unsubscribepage-thankumsg"
      },
      [
        _c(
          "div",
          {
            staticClass:
              "box-sub-heading thankyou-custom-content content-textleft spam-email"
          },
          [_vm._v("Your email address has been blocked.")]
        )
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fe0095be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe0095be","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CommunityRequestPageV2.vue
// module id = null
// module chunks = 